// local
// export const EIMZO_URL = 'ws://127.0.0.1:64646/service/cryptapi';
// export const EIMZO_HOST = 'localhost';
// export const EIMZO_API_KEY = '96D0C1491615C82B9A54D9989779DF825B690748224C2B04F500F370D51827CE2644D8D4A82C18184D73AB8530BB8ED537269603F61DB0D03D2104ABF789970B';

// prod
export const EIMZO_URL = 'ws://127.0.0.1:64646/service/cryptapi'
export const EIMZO_HOST = 'hybrid.pochta.uz';
export const EIMZO_API_KEY = '5699EB058EECE36422BE1B53E710B691708443D32338F1C93363B6017C22FA1D46F4BA9E7F1E3BA7AB0D35283EFF12BDCA4A06020BBA3F4126891C92C46EAF74';